// extracted by mini-css-extract-plugin
export default {"wrapper":"FilesFolderLogViewerStub__wrapper--1lxgi","regular":"FilesFolderLogViewerStub__regular--2-aXS"};